"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6.42.76A1 1 0 017.39 0h1.22a1 1 0 01.97.76l.34 1.35 1 .34.96-.64a1 1 0 011.26.13l.92.92a1 1 0 01.13 1.26L13.6 5l.72 1.08 1 .33a1 1 0 01.68.95v1.28a1 1 0 01-.68.95l-1 .33L13.6 11l.59.88a1 1 0 01-.13 1.26l-.92.92a1 1 0 01-1.26.13l-.95-.64-1.01.34-.34 1.35a1 1 0 01-.97.76H7.39a1 1 0 01-.97-.76l-.34-1.35-1-.34-.96.64a1 1 0 01-1.26-.13l-.92-.92a1 1 0 01-.13-1.26l.64-.95-.34-1.01-1.35-.34A1 1 0 010 8.61V7.39a1 1 0 01.76-.97l1.35-.34.34-1-.64-.96a1 1 0 01.13-1.26l.92-.92a1 1 0 011.26-.13l.95.64 1.01-.34.34-1.35zM8.61 1H7.39l-.34 1.35a1 1 0 01-.65.71l-1.01.34a1 1 0 01-.87-.12l-.96-.64-.92.92.64.96a1 1 0 01.12.87l-.34 1a1 1 0 01-.7.66L1 7.4v1.22l1.35.34a1 1 0 01.71.65l.34 1.01a1 1 0 01-.12.87l-.64.96.92.92.96-.64a1 1 0 01.87-.12l1 .34a1 1 0 01.66.7L7.4 15h1.22l.34-1.36a1 1 0 01.65-.7l1.01-.34a1 1 0 01.87.12l.96.64.92-.92-.6-.89a1 1 0 010-1.1l.73-1.08a1 1 0 01.51-.4l1-.33V7.36l-1-.33a1 1 0 01-.51-.4l-.72-1.08a1 1 0 010-1.1l.59-.89-.92-.92-.96.64a1 1 0 01-.87.12l-1-.34a1 1 0 01-.66-.7L8.6 1zM8 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM4.5 8a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
}));

exports["default"] = _default;